function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _regeneratorRuntime() {
  "use strict";

  var r = _regenerator(),
    e = r.m(_regeneratorRuntime),
    t = (Object.getPrototypeOf ? Object.getPrototypeOf(e) : e.__proto__).constructor;
  function n(r) {
    var e = "function" == typeof r && r.constructor;
    return !!e && (e === t || "GeneratorFunction" === (e.displayName || e.name));
  }
  var o = {
    throw: 1,
    return: 2,
    break: 3,
    continue: 3
  };
  function a(r) {
    var e, t;
    return function (n) {
      e || (e = {
        stop: function stop() {
          return t(n.a, 2);
        },
        catch: function _catch() {
          return n.v;
        },
        abrupt: function abrupt(r, e) {
          return t(n.a, o[r], e);
        },
        delegateYield: function delegateYield(r, o, a) {
          return e.resultName = o, t(n.d, _regeneratorValues(r), a);
        },
        finish: function finish(r) {
          return t(n.f, r);
        }
      }, t = function t(r, _t, o) {
        n.p = e.prev, n.n = e.next;
        try {
          return r(_t, o);
        } finally {
          e.next = n.n;
        }
      }), e.resultName && (e[e.resultName] = n.v, e.resultName = void 0), e.sent = n.v, e.next = n.n;
      try {
        return r.call(this, e);
      } finally {
        n.p = e.prev, n.n = e.next;
      }
    };
  }
  return (_regeneratorRuntime = function _regeneratorRuntime() {
    return {
      wrap: function wrap(e, t, n, o) {
        return r.w(a(e), t, n, o && o.reverse());
      },
      isGeneratorFunction: n,
      mark: r.m,
      awrap: function awrap(r, e) {
        return new _OverloadYield(r, e);
      },
      AsyncIterator: _regeneratorAsyncIterator,
      async: function async(r, e, t, o, u) {
        return (n(e) ? _regeneratorAsyncGen : _regeneratorAsync)(a(r), e, t, o, u);
      },
      keys: _regeneratorKeys,
      values: _regeneratorValues
    };
  })();
}
function _regeneratorValues(e) {
  if (null != e) {
    var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"],
      r = 0;
    if (t) return t.call(e);
    if ("function" == typeof e.next) return e;
    if (!isNaN(e.length)) return {
      next: function next() {
        return e && r >= e.length && (e = void 0), {
          value: e && e[r++],
          done: !e
        };
      }
    };
  }
  throw new TypeError(_typeof(e) + " is not iterable");
}
function _regeneratorKeys(e) {
  var n = Object(e),
    r = [];
  for (var t in n) r.unshift(t);
  return function e() {
    for (; r.length;) if ((t = r.pop()) in n) return e.value = t, e.done = !1, e;
    return e.done = !0, e;
  };
}
function _regeneratorAsync(n, e, r, t, o) {
  var a = _regeneratorAsyncGen(n, e, r, t, o);
  return a.next().then(function (n) {
    return n.done ? n.value : a.next();
  });
}
function _regeneratorAsyncGen(r, e, t, o, n) {
  return new _regeneratorAsyncIterator(_regenerator().w(r, e, t, o), n || Promise);
}
function _regeneratorAsyncIterator(t, e) {
  function n(r, o, i, f) {
    try {
      var c = t[r](o),
        u = c.value;
      return u instanceof _OverloadYield ? e.resolve(u.v).then(function (t) {
        n("next", t, i, f);
      }, function (t) {
        n("throw", t, i, f);
      }) : e.resolve(u).then(function (t) {
        c.value = t, i(c);
      }, function (t) {
        return n("throw", t, i, f);
      });
    } catch (t) {
      f(t);
    }
  }
  var r;
  this.next || (_regeneratorDefine2(_regeneratorAsyncIterator.prototype), _regeneratorDefine2(_regeneratorAsyncIterator.prototype, "function" == typeof Symbol && Symbol.asyncIterator || "@asyncIterator", function () {
    return this;
  })), _regeneratorDefine2(this, "_invoke", function (t, o, i) {
    function f() {
      return new e(function (e, r) {
        n(t, i, e, r);
      });
    }
    return r = r ? r.then(f, f) : f();
  }, !0);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };
      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2(e, r, n, t);
}
function _OverloadYield(e, d) {
  this.v = e, this.k = d;
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
import { computePosition as st, flip as rt, autoPlacement as ct } from "../../../../../@floating-ui_core@1.7.3/node_modules/@floating-ui/core/dist/floating-ui.core.js";
import { createCoords as w, rectToClientRect as J, floor as A, max as E, round as D, min as V } from "../../../../../@floating-ui_utils@0.2.10/node_modules/@floating-ui/utils/dist/floating-ui.utils.js";
import { getOverflowAncestors as z, isElement as v, getDocumentElement as R, getWindow as L, getFrameElement as U, getComputedStyle as b, isHTMLElement as C, isWebKit as Q, isTopLayer as _, getParentNode as W, isLastTraversableNode as H, isTableElement as lt, isContainingBlock as Y, getContainingBlock as ft, getNodeName as $, isOverflowElement as P, getNodeScroll as I } from "../../../../../@floating-ui_utils@0.2.10/node_modules/@floating-ui/utils/dist/floating-ui.utils.dom.js";
function Z(t) {
  var e = b(t);
  var o = parseFloat(e.width) || 0,
    n = parseFloat(e.height) || 0;
  var i = C(t),
    r = i ? t.offsetWidth : o,
    s = i ? t.offsetHeight : n,
    c = D(o) !== r || D(n) !== s;
  return c && (o = r, n = s), {
    width: o,
    height: n,
    $: c
  };
}
function q(t) {
  return v(t) ? t : t.contextElement;
}
function F(t) {
  var e = q(t);
  if (!C(e)) return w(1);
  var o = e.getBoundingClientRect(),
    _Z = Z(e),
    n = _Z.width,
    i = _Z.height,
    r = _Z.$;
  var s = (r ? D(o.width) : o.width) / n,
    c = (r ? D(o.height) : o.height) / i;
  return (!s || !Number.isFinite(s)) && (s = 1), (!c || !Number.isFinite(c)) && (c = 1), {
    x: s,
    y: c
  };
}
var ut = w(0);
function tt(t) {
  var e = L(t);
  return !Q() || !e.visualViewport ? ut : {
    x: e.visualViewport.offsetLeft,
    y: e.visualViewport.offsetTop
  };
}
function at(t, e, o) {
  return e === void 0 && (e = !1), !o || e && o !== L(t) ? !1 : e;
}
function T(t, e, o, n) {
  e === void 0 && (e = !1), o === void 0 && (o = !1);
  var i = t.getBoundingClientRect(),
    r = q(t);
  var s = w(1);
  e && (n ? v(n) && (s = F(n)) : s = F(t));
  var c = at(r, o, n) ? tt(r) : w(0);
  var f = (i.left + c.x) / s.x,
    l = (i.top + c.y) / s.y,
    u = i.width / s.x,
    a = i.height / s.y;
  if (r) {
    var d = L(r),
      h = n && v(n) ? L(n) : n;
    var m = d,
      p = U(m);
    for (; p && n && h !== m;) {
      var y = F(p),
        g = p.getBoundingClientRect(),
        x = b(p),
        O = g.left + (p.clientLeft + parseFloat(x.paddingLeft)) * y.x,
        S = g.top + (p.clientTop + parseFloat(x.paddingTop)) * y.y;
      f *= y.x, l *= y.y, u *= y.x, a *= y.y, f += O, l += S, m = L(p), p = U(m);
    }
  }
  return J({
    width: u,
    height: a,
    x: f,
    y: l
  });
}
function M(t, e) {
  var o = I(t).scrollLeft;
  return e ? e.left + o : T(R(t)).left + o;
}
function et(t, e) {
  var o = t.getBoundingClientRect(),
    n = o.left + e.scrollLeft - M(t, o),
    i = o.top + e.scrollTop;
  return {
    x: n,
    y: i
  };
}
function ht(t) {
  var e = t.elements,
    o = t.rect,
    n = t.offsetParent,
    i = t.strategy;
  var r = i === "fixed",
    s = R(n),
    c = e ? _(e.floating) : !1;
  if (n === s || c && r) return o;
  var f = {
      scrollLeft: 0,
      scrollTop: 0
    },
    l = w(1);
  var u = w(0),
    a = C(n);
  if ((a || !a && !r) && (($(n) !== "body" || P(s)) && (f = I(n)), C(n))) {
    var h = T(n);
    l = F(n), u.x = h.x + n.clientLeft, u.y = h.y + n.clientTop;
  }
  var d = s && !a && !r ? et(s, f) : w(0);
  return {
    width: o.width * l.x,
    height: o.height * l.y,
    x: o.x * l.x - f.scrollLeft * l.x + u.x + d.x,
    y: o.y * l.y - f.scrollTop * l.y + u.y + d.y
  };
}
function dt(t) {
  return Array.from(t.getClientRects());
}
function gt(t) {
  var e = R(t),
    o = I(t),
    n = t.ownerDocument.body,
    i = E(e.scrollWidth, e.clientWidth, n.scrollWidth, n.clientWidth),
    r = E(e.scrollHeight, e.clientHeight, n.scrollHeight, n.clientHeight);
  var s = -o.scrollLeft + M(t);
  var c = -o.scrollTop;
  return b(n).direction === "rtl" && (s += E(e.clientWidth, n.clientWidth) - i), {
    width: i,
    height: r,
    x: s,
    y: c
  };
}
var K = 25;
function pt(t, e) {
  var o = L(t),
    n = R(t),
    i = o.visualViewport;
  var r = n.clientWidth,
    s = n.clientHeight,
    c = 0,
    f = 0;
  if (i) {
    r = i.width, s = i.height;
    var u = Q();
    (!u || u && e === "fixed") && (c = i.offsetLeft, f = i.offsetTop);
  }
  var l = M(n);
  if (l <= 0) {
    var _u = n.ownerDocument,
      a = _u.body,
      d = getComputedStyle(a),
      h = _u.compatMode === "CSS1Compat" && parseFloat(d.marginLeft) + parseFloat(d.marginRight) || 0,
      m = Math.abs(n.clientWidth - a.clientWidth - h);
    m <= K && (r -= m);
  } else l <= K && (r += l);
  return {
    width: r,
    height: s,
    x: c,
    y: f
  };
}
var mt = new Set(["absolute", "fixed"]);
function yt(t, e) {
  var o = T(t, !0, e === "fixed"),
    n = o.top + t.clientTop,
    i = o.left + t.clientLeft,
    r = C(t) ? F(t) : w(1),
    s = t.clientWidth * r.x,
    c = t.clientHeight * r.y,
    f = i * r.x,
    l = n * r.y;
  return {
    width: s,
    height: c,
    x: f,
    y: l
  };
}
function j(t, e, o) {
  var n;
  if (e === "viewport") n = pt(t, o);else if (e === "document") n = gt(R(t));else if (v(e)) n = yt(e, o);else {
    var i = tt(t);
    n = {
      x: e.x - i.x,
      y: e.y - i.y,
      width: e.width,
      height: e.height
    };
  }
  return J(n);
}
function nt(t, e) {
  var o = W(t);
  return o === e || !v(o) || H(o) ? !1 : b(o).position === "fixed" || nt(o, e);
}
function wt(t, e) {
  var o = e.get(t);
  if (o) return o;
  var n = z(t, [], !1).filter(function (c) {
      return v(c) && $(c) !== "body";
    }),
    i = null;
  var r = b(t).position === "fixed";
  var s = r ? W(t) : t;
  for (; v(s) && !H(s);) {
    var c = b(s),
      f = Y(s);
    !f && c.position === "fixed" && (i = null), (r ? !f && !i : !f && c.position === "static" && !!i && mt.has(i.position) || P(s) && !f && nt(t, s)) ? n = n.filter(function (u) {
      return u !== s;
    }) : i = c, s = W(s);
  }
  return e.set(t, n), n;
}
function xt(t) {
  var e = t.element,
    o = t.boundary,
    n = t.rootBoundary,
    i = t.strategy;
  var s = [].concat(_toConsumableArray(o === "clippingAncestors" ? _(e) ? [] : wt(e, this._c) : [].concat(o)), [n]),
    c = s[0],
    f = s.reduce(function (l, u) {
      var a = j(e, u, i);
      return l.top = E(a.top, l.top), l.right = V(a.right, l.right), l.bottom = V(a.bottom, l.bottom), l.left = E(a.left, l.left), l;
    }, j(e, c, i));
  return {
    width: f.right - f.left,
    height: f.bottom - f.top,
    x: f.left,
    y: f.top
  };
}
function vt(t) {
  var _Z2 = Z(t),
    e = _Z2.width,
    o = _Z2.height;
  return {
    width: e,
    height: o
  };
}
function bt(t, e, o) {
  var n = C(e),
    i = R(e),
    r = o === "fixed",
    s = T(t, !0, r, e);
  var c = {
    scrollLeft: 0,
    scrollTop: 0
  };
  var f = w(0);
  function l() {
    f.x = M(i);
  }
  if (n || !n && !r) if (($(e) !== "body" || P(i)) && (c = I(e)), n) {
    var h = T(e, !0, r, e);
    f.x = h.x + e.clientLeft, f.y = h.y + e.clientTop;
  } else i && l();
  r && !n && i && l();
  var u = i && !n && !r ? et(i, c) : w(0),
    a = s.left + c.scrollLeft - f.x - u.x,
    d = s.top + c.scrollTop - f.y - u.y;
  return {
    x: a,
    y: d,
    width: s.width,
    height: s.height
  };
}
function N(t) {
  return b(t).position === "static";
}
function G(t, e) {
  if (!C(t) || b(t).position === "fixed") return null;
  if (e) return e(t);
  var o = t.offsetParent;
  return R(t) === o && (o = o.ownerDocument.body), o;
}
function ot(t, e) {
  var o = L(t);
  if (_(t)) return o;
  if (!C(t)) {
    var i = W(t);
    for (; i && !H(i);) {
      if (v(i) && !N(i)) return i;
      i = W(i);
    }
    return o;
  }
  var n = G(t, e);
  for (; n && lt(n) && N(n);) n = G(n, e);
  return n && H(n) && N(n) && !Y(n) ? o : n || ft(t) || o;
}
var Rt = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(t) {
    var e, o, n;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          e = this.getOffsetParent || ot;
          o = this.getDimensions;
          _context.next = 4;
          return o(t.floating);
        case 4:
          n = _context.sent;
          _context.t0 = bt;
          _context.t1 = t.reference;
          _context.next = 9;
          return e(t.floating);
        case 9:
          _context.t2 = _context.sent;
          _context.t3 = t.strategy;
          _context.t4 = (0, _context.t0)(_context.t1, _context.t2, _context.t3);
          _context.t5 = {
            x: 0,
            y: 0,
            width: n.width,
            height: n.height
          };
          return _context.abrupt("return", {
            reference: _context.t4,
            floating: _context.t5
          });
        case 14:
        case "end":
          return _context.stop();
      }
    }, _callee, this);
  }));
  return function Rt(_x) {
    return _ref.apply(this, arguments);
  };
}();
function Ct(t) {
  return b(t).direction === "rtl";
}
var Ot = {
  convertOffsetParentRelativeRectToViewportRelativeRect: ht,
  getDocumentElement: R,
  getClippingRect: xt,
  getOffsetParent: ot,
  getElementRects: Rt,
  getClientRects: dt,
  getDimensions: vt,
  getScale: F,
  isElement: v,
  isRTL: Ct
};
function it(t, e) {
  return t.x === e.x && t.y === e.y && t.width === e.width && t.height === e.height;
}
function Lt(t, e) {
  var o = null,
    n;
  var i = R(t);
  function r() {
    var c;
    clearTimeout(n), (c = o) == null || c.disconnect(), o = null;
  }
  function s(c, f) {
    c === void 0 && (c = !1), f === void 0 && (f = 1), r();
    var l = t.getBoundingClientRect(),
      u = l.left,
      a = l.top,
      d = l.width,
      h = l.height;
    if (c || e(), !d || !h) return;
    var m = A(a),
      p = A(i.clientWidth - (u + d)),
      y = A(i.clientHeight - (a + h)),
      g = A(u),
      O = {
        rootMargin: -m + "px " + -p + "px " + -y + "px " + -g + "px",
        threshold: E(0, V(1, f)) || 1
      };
    var S = !0;
    function X(k) {
      var B = k[0].intersectionRatio;
      if (B !== f) {
        if (!S) return s();
        B ? s(!1, B) : n = setTimeout(function () {
          s(!1, 1e-7);
        }, 1e3);
      }
      B === 1 && !it(l, t.getBoundingClientRect()) && s(), S = !1;
    }
    try {
      o = new IntersectionObserver(X, _objectSpread(_objectSpread({}, O), {}, {
        root: i.ownerDocument
      }));
    } catch (_unused) {
      o = new IntersectionObserver(X, O);
    }
    o.observe(t);
  }
  return s(!0), r;
}
function Wt(t, e, o, n) {
  n === void 0 && (n = {});
  var _n = n,
    _n$ancestorScroll = _n.ancestorScroll,
    i = _n$ancestorScroll === void 0 ? !0 : _n$ancestorScroll,
    _n$ancestorResize = _n.ancestorResize,
    r = _n$ancestorResize === void 0 ? !0 : _n$ancestorResize,
    _n$elementResize = _n.elementResize,
    s = _n$elementResize === void 0 ? typeof ResizeObserver == "function" : _n$elementResize,
    _n$layoutShift = _n.layoutShift,
    c = _n$layoutShift === void 0 ? typeof IntersectionObserver == "function" : _n$layoutShift,
    _n$animationFrame = _n.animationFrame,
    f = _n$animationFrame === void 0 ? !1 : _n$animationFrame,
    l = q(t),
    u = i || r ? [].concat(_toConsumableArray(l ? z(l) : []), _toConsumableArray(z(e))) : [];
  u.forEach(function (g) {
    i && g.addEventListener("scroll", o, {
      passive: !0
    }), r && g.addEventListener("resize", o);
  });
  var a = l && c ? Lt(l, o) : null;
  var d = -1,
    h = null;
  s && (h = new ResizeObserver(function (g) {
    var _g = _slicedToArray(g, 1),
      x = _g[0];
    x && x.target === l && h && (h.unobserve(e), cancelAnimationFrame(d), d = requestAnimationFrame(function () {
      var O;
      (O = h) == null || O.observe(e);
    })), o();
  }), l && !f && h.observe(l), h.observe(e));
  var m,
    p = f ? T(t) : null;
  f && y();
  function y() {
    var g = T(t);
    p && !it(p, g) && o(), p = g, m = requestAnimationFrame(y);
  }
  return o(), function () {
    var g;
    u.forEach(function (x) {
      i && x.removeEventListener("scroll", o), r && x.removeEventListener("resize", o);
    }), a !== null && a !== void 0 && a(), (g = h) == null || g.disconnect(), h = null, f && cancelAnimationFrame(m);
  };
}
var St = ct,
  Bt = rt,
  At = function At(t, e, o) {
    var n = new Map(),
      i = _objectSpread({
        platform: Ot
      }, o),
      r = _objectSpread(_objectSpread({}, i.platform), {}, {
        _c: n
      });
    return st(t, e, _objectSpread(_objectSpread({}, i), {}, {
      platform: r
    }));
  };
export { St as autoPlacement, Wt as autoUpdate, At as computePosition, Bt as flip, z as getOverflowAncestors, Ot as platform };